// extracted by mini-css-extract-plugin
module.exports = {"container":"jk-z","heading":"kk-z","links":"lk-z","linkBtn":"mk-z","disabled":"nk-z","linkUppercaseBold":"ok-z","copy":"pk-z","subCopy":"qk-z"};